import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { block } from '../../utils/block.js';
import './ProgressBar.scss.js';
import { jsx } from 'react/jsx-runtime';

const _excluded = ["amountOfSteps", "currentStep", "className"];
const b = block('progress-bar');
const ProgressBar = _ref => {
  let {
      amountOfSteps,
      currentStep,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (amountOfSteps === 0) {
    return null;
  }
  return /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({
    className: b().mix(className)
  }, rest), {}, {
    children: Array(amountOfSteps - 1).fill(0).map((_, i) => /*#__PURE__*/jsx("div", {
      className: b('step', {
        active: i < currentStep
      })
    }, i))
  }));
};

export { ProgressBar };
